export default {"src":"/_next/static/media/WhoWeAre_041A.e288544b.JPG","height":694,"width":1920};